module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg"
  }, [_c('div', [(_vm.showProcessToast) ? _c('div', [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.showtip) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title"
  }, [_vm._v("拒绝访问")]), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_c('p', {
    staticClass: "weui-btn-area"
  }, [_c('a', {
    staticClass: "weui-btn weui-btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePage.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__extra-area"
  }, [_c('div', {
    staticClass: "weui-footer"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "weui-footer__text"
  }, [_vm._v("Copyright © 2025-" + _vm._s(new Date().getFullYear()) + " ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("登录信息失效，正在跳往登录页...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon-warn weui-icon_msg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "weui-footer__links"
  }, [_c('a', {
    staticClass: "weui-footer__link",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("南京微沐软件科技有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7253ebe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginAuthen.vue
// module id = 145
// module chunks = 2